import ServicePath from "@/core/ServicePath"
import { MainRequest } from "@/core/request";

export default class CalculatorsSomatometryRequest extends MainRequest{

   static getCalculatorsSomatometry(data) {
      return this.postSEC(ServicePath.CALCULATORS_SOMATOMETRY, data);
   }

   static saveCalculatorsSomatometry(data) {
      return this.postSEC(ServicePath.CALCULATORS_SOMATOMETRY_SAVE, data);
 }

 static editCalculatorsSomatometry(data) {
   return this.postSEC(ServicePath.CALCULATORS_SOMATOMETRY_EDIT, data);
}


}